const WORKFLOW_TYPES = Object.freeze({
    ACTIONS: 'actions',
    STEPS: 'steps',
    WORKFLOWS: 'workflows'
});

export default WORKFLOW_TYPES;